






import { shellLocalConfig } from '@src/config/shell/localConfig';
import { defineComponent } from '@vue/composition-api';

import { getFederationComponent } from '../getFederationComponent';

export default defineComponent({
    name: 'UseFreeToPlayEligibilityChecker',
    setup() {
        return {
            useEligibilityChecker: shellLocalConfig.freeToPlay.useEligibilityChecker,
        };
    },
    components: {
        FreeToPlayEligibilityChecker: getFederationComponent(() => import('gaming/FreeToPlayEligibilityChecker')),
    },
});
